/*
 * @license
 * Copyright© Celligence International, LLC - 2023
 *
 * This software program is protected by copyright laws and is the property of
 * Celligence International, LLC (Celligence). Any unauthorized reproduction,
 * distribution, modification, or public display of this program, without the
 * explicit permission of Celligence is strictly prohibited. If you have gained
 * access to this program without the expressed approval of Celligence report
 * the incident to legal@celligence.com.
 *
 */

import React, { useState, useEffect } from "react";
import "./index.css";

const UserWayAccessibilityMenu = ({ width, height, showAngelAiHeader }) => {
  const [color, setColor] = useState("white");

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 650) {
        setColor("black"); // Change to black when scrolled past 50px
      } else {
        setColor("white"); // Default to white at the top
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const accessibilityIcon = `${process.env.REACT_APP_CDN}swmc/images/accessibility-icon-wheel_left_${color}.svg`;

  return (
    <div className={`userWayContainer ${showAngelAiHeader ? "userWayContainerAngelAi" : ""}`}>
      <button
        id="UserWayAccessibilityMenu"
        title="Accessibility Menu"
        className="userWayBackGroundBody"
        onClick={() => {
          if (window.UserWay && typeof window.UserWay.widgetToggle === "function") {
            window.UserWay.widgetToggle();
          }
        }}
      >
        <img src={accessibilityIcon} alt="Open the Accessibility Menu" style={{ width, height }} />
      </button>
    </div>
  );
};

export default UserWayAccessibilityMenu;